const mcp_types = [
    {
        value: 'demo',
        name: 'Demo'
    },
];

export {mcp_types};


// WEBPACK FOOTER //
// ./resources/assets/js/include/FireAlarmForm.js